import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { BannerApiService, BannerStatusValues, BannerTargetValues, BannerTypeValues } from '@core';
import { BannerEntity } from '@models';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-banners',
    standalone: true,
    imports: [CacTableComponent],
    templateUrl: './banners.component.html',
    styleUrl: './banners.component.scss',
})
export class BannersComponent {
    private readonly bannerApi = inject(BannerApiService);

    table = table({
        itemsFn: this.bannerApi.getAdapter(),
        view: {
            itemName: 'Banner',
        },
        columns: {

            id: { label: 'ID' },
            title: {
                label: 'Title',
                transform: (v) => { return this.getLocalizedText(v) },
            },
            image: { label: 'Image', type: 'image', transform: (v) => v?.url, filterable: false },
            type: {
                label: 'Linked To',
                items: BannerTypeValues,
            },
            description: {
                label: 'Description',
                transform: (v) => { return this.getLocalizedText(v) },
            },
            order: {
                label: 'Order',
                filterable: false,
            },
            status: {
                label: 'Status',
                items: BannerStatusValues,
            },
            target: {
                label: 'Target',
                items: BannerTargetValues,
            },
        },
        actions: [
            {
                type: 'icon',
                content: 'edit',
                action: (item: BannerEntity) => 
                    this.bannerApi.getBannerDetail(item.id).pipe(
                        switchMap(bannerDetail => dialog$.banner({ 
                            banner: bannerDetail.banner, 
                            bannerId: item.id 
                        }).afterSubmit())
                    ),
            },
        ],

        bulkActions: [
            {
                content: 'Delete',
                action: (items) => {
                    return dialog$.deletePrompt().action(() => this.bannerApi.deleteBanners(items.map((x) => x.id)));
                }
            }

        ],
        events: {
            add: () => dialog$.banner().afterSubmit(),
        },
    });
    private getLocalizedText(v: any) {
        if (v.arabic & v.english) {
            return `${v.english} | ${v.arabic}`;
        }
        else if (v.arabic) { return v.arabic; }
        else if (v.english) { return v.english; }
    }
}

